import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { CDropdownItem } from '@/components/shared/CDropdown';
import { DateFormat, formatDate } from '@/utils/dates';
import store from '@/store';
import { AccessMode, EntityType, TeamMember } from '@/api/typings/team';
import CDropdown from '@/components/shared/CDropdown';
import CUserAvatar from '@/components/shared/CUserAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamTable',
  props: {
    members: null
  },
  emits: ["edit-member", "manage-member-entity-access", "delete-member"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'edit-member', value: TeamMember): void;
    (event: 'manage-member-entity-access', value: { member: TeamMember; entityType: EntityType }): void;
    (event: 'delete-member', value: TeamMember): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    members: TeamMember[];
};

const user = computed(() => store.state.user);





const fields = [
    {
        key: 'name',
        label: 'Name',
        sortable: true
    },
    {
        key: 'date',
        label: 'Creation date',
        sortable: true
    },
    {
        key: 'actions',
        label: '',
        sortable: false
    }
];

const getCDropdownActionsForItem = (item: TeamMember): CDropdownItem[] => {
    return user.value?.ImpersonatedFromChildUser
        ? []
        : [
              {
                  label: 'Edit member',
                  callback: () => onEditMember(item)
              },
              {
                  label: 'Manage access to templates',
                  disabled: item.accessMode == AccessMode.FULL,
                  divider: true,
                  callback: () => {
                      item.accessMode != AccessMode.FULL
                          ? onManageMemberEntityAccess(item, EntityType.TEMPLATE)
                          : undefined;
                  },
                  class: item.accessMode == AccessMode.FULL ? 'text-danger-dark' : undefined
              },
              {
                  label: 'Manage access to libraries',
                  disabled: item.accessMode == AccessMode.FULL,
                  divider: true,
                  callback: () => {
                      item.accessMode != AccessMode.FULL
                          ? onManageMemberEntityAccess(item, EntityType.LIBRARY)
                          : undefined;
                  }
              },
              {
                  label: 'Manage access to stores',
                  disabled: item.accessMode == AccessMode.FULL,
                  divider: true,
                  callback: () => {
                      item.accessMode != AccessMode.FULL
                          ? onManageMemberEntityAccess(item, EntityType.STORE)
                          : undefined;
                  }
              },
              {
                  label: 'Manage access to products',
                  disabled: item.accessMode == AccessMode.FULL,
                  divider: true,
                  callback: () => {
                      item.accessMode != AccessMode.FULL
                          ? onManageMemberEntityAccess(item, EntityType.PRODUCT)
                          : undefined;
                  }
              },
              {
                  label: 'Manage access to option sets',
                  disabled: item.accessMode == AccessMode.FULL,
                  divider: true,
                  callback: () => {
                      item.accessMode != AccessMode.FULL
                          ? onManageMemberEntityAccess(item, EntityType.OPTION_SET)
                          : undefined;
                  }
              },
              {
                  label: 'Delete member',
                  divider: true,
                  callback: () => onDeleteMember(item),
                  class: 'text-danger-dark'
              }
          ].filter((i) => !i.disabled);
};

const userItems = computed(() => {
    return props.members.map((i) => ({
        date: formatDate(i.user.CreatedDate!, DateFormat.MMMddYYYYTime),
        ...i
    }));
});

const onEditMember = (user: TeamMember) => {
    emit('edit-member', user);
};

const onManageMemberEntityAccess = (user: TeamMember, entityType: EntityType) => {
    emit('manage-member-entity-access', { member: user, entityType });
};

const onDeleteMember = (user: TeamMember) => {
    emit('delete-member', user);
};

return { __sfc: true,user, props, emit, fields, getCDropdownActionsForItem, userItems, onEditMember, onManageMemberEntityAccess, onDeleteMember, AccessMode, CDropdown, CUserAvatar }
}

})